import React from "react";
import styled from "./Instruction.module.scss";
import { TbGridDots } from "react-icons/tb";
import { RiErrorWarningFill } from "react-icons/ri";
import { FaUserLarge } from "react-icons/fa6";
import { MdLocationOn } from "react-icons/md";
import { MdPhone } from "react-icons/md";
import { MdDateRange } from "react-icons/md";
import { MdPayments } from "react-icons/md";

const OxygenScheduled = (props) => {
  const thirdDay = props.schedule_date
    ? new Date(
        new Date(props.schedule_date).setDate(
          new Date(props.schedule_date).getDate() + 3
        )
      )
    : "";

  const formattedThirdDay = thirdDay
    ? thirdDay.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "numeric",
        year: "numeric",
      })
    : "-";

  return (
    <div>
      <div className="d-flex flex-column justify-content-center">
        <div className="d-flex justify-content-between mt-3 mb-3">
          <p className={styled.header} style={{ color: props.headerColor }}>
            ORDER DETAILS{" | "}LBO
            <span>{props.orderId}</span>
          </p>

          {/* <p
            className={styled.name}
            style={{
              background: props.categoryBg,
              color: props.categoryColor,
              textTransform: "uppercase",
            }}
          >
            {props.category ? props.category : "oxygen"}
          </p> */}
        </div>

        <div className={styled.modalContainer1}>
          <div className="d-flex align-items-center gap-2 p-2">
            <TbGridDots size={20} color="#0779F7" />
            <p className={styled.title}>product name</p>
          </div>
          <div className={styled.line}></div>
          <p className={styled.content}>{props?.product}</p>
        </div>
        {/* <div className={styled.modalContainer1}>
          <div className="d-flex align-items-center gap-2 p-2">
            <RiErrorWarningFill size={20} color="#8B23A580" />
            <p className={styled.title}>Order Type</p>
          </div>
          <div className={styled.line}></div>
          <div className="d-flex align-items-center justify-content-between w-100">
            <div>
              <p className={styled.content}>{props?.urgency}</p>
            </div>

            {props?.urgency === "emergency" && (
              <div className="d-flex align-items-center gap-2 p-2">
                <div
                  style={{
                    background: "#b70303",
                    width: "20px",
                    height: "10px",
                  }}
                ></div>
                <p className={styled.urgent}>Critical</p>
              </div>
            )}
          </div>
        </div> */}
        {/* <div className={styled.modalContainer1}>
          <p className={styled.title}>size</p>
          <div className={styled.line}></div>
          <p className={styled.content}>{props.size}</p>
        </div> */}
        {props?.urgency !== "emergency" && (
          <div className={styled.modalContainer1}>
            <div className="d-flex align-items-center gap-2 p-2">
              <MdDateRange size={20} color="#00CC7A" />
              <p className={styled.title}>Pickup Date</p>
            </div>
            <div className={styled.line}></div>
            <p className={styled.content}>
              {props?.schedule_date ? props?.schedule_date : "-"}
            </p>
          </div>
        )}

        {props?.urgency !== "emergency" && (
          <div className={styled.modalContainer1}>
            <div className="d-flex align-items-center gap-2 p-2">
              <MdDateRange size={20} color="#639C52" />
              <p className={styled.title}>Delivery Date</p>
            </div>
            <div className={styled.line}></div>
            <p className={styled.content}>{formattedThirdDay}</p>
          </div>
        )}
        <div className={styled.modalContainer1}>
          <div className="d-flex align-items-center gap-2 p-2">
            <TbGridDots size={20} color="#888404" />
            <p className={styled.title}>Quantity</p>
          </div>
          <div className={styled.line}></div>
          <p className={styled.content}>{props.quantity}</p>
        </div>
        {props.payment && (
          <div className={styled.modalContainer1}>
            <div className="d-flex align-items-center gap-2 p-2">
              <MdPayments size={20} color="#CC00B1" />
              <p className={styled.title}>Payment Type</p>
            </div>
            <div className={styled.line}></div>
            <p className={styled.content}>{props.payment}</p>
          </div>
        )}
        <div className={styled.modalContainer1}>
          <div className="d-flex align-items-center gap-2 p-2">
            <FaUserLarge size={20} color="#5FCC00" />
            <p className={styled.title}>Hospital Name</p>
          </div>

          <div className={styled.line}></div>
          <p className={styled.content}>{props.hospital}</p>
        </div>

        <div className={styled.modalContainer1}>
          <div className="d-flex align-items-center gap-2 p-2">
            <MdLocationOn size={20} color="#CC00B1" />
            <p className={styled.title}>Hospital Address</p>
          </div>

          <div className={styled.line}></div>
          <p className={styled.content}>{props.address}</p>
        </div>
        {/* <div className={styled.modalContainer1}>
          <div className="d-flex align-items-center gap-2 p-2">
            <MdPhone size={20} color="#005350" />
            <p className={styled.title}>Hospital's Contact</p>
          </div>

          <div className={styled.line}></div>
          <p className={styled.content}>{props.phone}</p>
        </div> */}
        <div className={styled.modalContainer1}>
          <div className="d-flex align-items-center gap-2 p-2">
            <MdDateRange size={20} color="#CC6600" />
            <p className={styled.title}>Order Time</p>
          </div>
          <div className={styled.line}></div>
          <p className={styled.content}>{props.time}</p>
        </div>
        <div className="d-flex justify-content-center">
          <button
            className={` shadow-none ${styled.actionBtn} ${styled.reject}`}
            style={{ background: props.btnColor }}
            onClick={() => props.onClickYes()}
          >
            {props.button2}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OxygenScheduled;
